export const handleOnlyNumbers=(value)=>{
    var numberRegex = /^(\d)*(\.)?([0-9]{1})?$/
    return numberRegex?.test(value)
}